import React from "react";
import PropTypes from "prop-types";

const HeaderModal = ({ modalContent }) => {
  // Add classes for mobile popup.
  const mobileClass = "popup-navigation--open pt-12 pb-16";
  // Add attr for div if mobile open.
  const attrForPopup = {
    role: "dialog",
    "aria-modal": true,
  };
  return (
    <>
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
      <div tabIndex="0" />
      <div className={`popup-navigation ${mobileClass}`} {...attrForPopup}>
        {modalContent}
      </div>
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
      <div tabIndex="0" />
    </>
  );
};

HeaderModal.propTypes = {
  modalContent: PropTypes.node.isRequired,
};

export default HeaderModal;
